import { useMyPermissions } from '../../../../hooks/useMyPermissions';
import { ButtonSpinner } from './CredsActionButtons';
import { DetailSlot } from './DetailSlot';
import { IteroConnectionBox } from './IteroConnectionBox';
import { isIteroBoxVisible } from './iteroBoxActions';

const ITERO_FIELD_LABEL = 'iTero';
const ITERO_FIELD_SPAN = 6;

interface IteroConnectionFieldProps {
    practiceId: string;
    practiceName: string;
}

// Shown for practices.itero.get or .update (each unlocks its own actions); hidden entirely without either.
export function IteroConnectionField({ practiceId, practiceName }: IteroConnectionFieldProps) {
    const { isLoading, hasPermission } = useMyPermissions();

    if (isLoading) {
        return (
            <DetailSlot label={ITERO_FIELD_LABEL} span={ITERO_FIELD_SPAN}>
                <div
                    role="status"
                    className="flex items-center gap-2 border border-gray-200 rounded-lg bg-gray-50 px-3 py-2.5 w-full"
                >
                    <ButtonSpinner />
                    <span className="sr-only">Checking iTero access</span>
                </div>
            </DetailSlot>
        );
    }

    const access = {
        canView: hasPermission('practices.itero.get'),
        canManage: hasPermission('practices.itero.update')
    };
    if (!isIteroBoxVisible(access)) return null;

    return (
        <DetailSlot label={ITERO_FIELD_LABEL} span={ITERO_FIELD_SPAN}>
            <IteroConnectionBox
                practiceId={practiceId}
                practiceName={practiceName}
                access={access}
            />
        </DetailSlot>
    );
}
